// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"388":"2fbf9dd2","895":"b5e6744d"}[chunkId] || chunkId) + "." + {"388":"d50bb743125db6e8","484":"7272115e10e199b4","561":"90d706780918c3ec","895":"3fce7dff565099f4"}[chunkId] + ".js";
};